import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-12 text-center">Parlons de votre <span className="text-orange-500">Projet</span></h1>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Informations de contact */}
            <div className="space-y-6">
              <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800 hover:border-orange-500 transition">
                <MapPin className="text-orange-500 mb-4" size={32} />
                <h3 className="text-xl font-bold mb-2">Notre Emplacement</h3>
                <p className="text-gray-400">Socimat / Gombe, Kinshasa, RD Congo.</p>
              </div>

              <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800 hover:border-orange-500 transition">
                <Phone className="text-orange-500 mb-4" size={32} />
                <h3 className="text-xl font-bold mb-2">Téléphone / WhatsApp</h3>
                <p className="text-gray-400">+243 828 706 717</p>
              </div>
            </div>

            {/* Horaires */}
            <div className="bg-gray-900 p-8 rounded-2xl border border-orange-500 flex flex-col items-center justify-center text-center">
              <Clock className="text-orange-500 mb-6" size={48} />
              <h3 className="text-2xl font-bold mb-6">Horaires d'ouverture</h3>
              <div className="space-y-3 text-gray-300">
                <p><span className="font-bold">Lun - Ven :</span> 08h00 - 18h00</p>
                <p><span className="font-bold">Samedi :</span> 09h00 - 15h00</p>
                <p className="text-orange-500 font-bold mt-4 italic text-sm italic">Dimanche : Fermé sur rendez-vous uniquement</p>
              </div>
              <a href="https://wa.me/243828706717" className="mt-8 bg-orange-500 text-white w-full py-4 rounded-xl font-bold hover:bg-orange-600 transition">Prendre rendez-vous</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
